errorHandling:
  generic:
    fallback: エラーが発生しました。後でもう一度お試しください。
    archived: 要求されたアイテムはアーカイブされています。
    notFound: 要求されたアイテムが見つかりませんでした。
    unauthorised: この操作を実行する権限がありません。
    validation: 検証に失敗しました。確認してもう一度お試しください。
errorPage:
  gone:
    title: このページはもう存在しません
    defaultMessage: お探しのページが削除されたか、名前が変更されたか、一時的に利用できない可能性があります。これが間違いだと思われる場合は、サポートチームにご連絡ください。
    button:
      primary: サポートに連絡
      secondary: ホームに戻る
  notFound:
    title: ページが見つかりません
    defaultMessage: お探しのページが見つからない場合がございます。
    button:
      primary: サポートに連絡する
      secondary: ホームに戻る
  denied:
    title: アクセスが拒否されました
    defaultMessage: アクセスしようとしているページは制限されており、権限がないようです。詳細については、サポートチームにお問い合わせください。
    button:
      primary: サポートに連絡
      secondary: ホームに戻る
  deniedProject:
    title: このプロジェクトへのアクセスを取得
    loggedOut: 閲覧するにはサインインしてください、またはチームメンバーに共有設定で「リンクを持つ全員」にプロジェクトアクセスを変更するよう依頼してください
    loggedIn: チームメンバーに共有設定で「リンクを持つ全員」にプロジェクトアクセスを更新するよう依頼してください。
    button:
      primary: サインイン
  crash:
    title: 何か問題が発生しました
    defaultMessage: もう一度試してください。または、この問題を解決するために手を貸してほしい場合は、サポートチームに連絡してください。
    button:
      primary: 再試行
      secondary: ホームに戻る
